import { atom } from "jotai";
import { atomWithStorage, createJSONStorage } from "jotai/utils";
import { z } from "zod";

export const storageKey = "actAsUser";
export const actAsSessionSchema = z.object({
  sessionId: z.string().min(1),
  token: z.string().min(1),
  actAsUserId: z.string().min(1),
  actAsUserName: z.string(),
  requesterUid: z.string().min(1),
  lastActivity: z.number().finite().nonnegative(),
  expiresAt: z.number().finite().positive(),
});
export type ActAsSession = z.infer<typeof actAsSessionSchema>;

export function parseActAsSession(value: unknown): ActAsSession | null {
  const result = actAsSessionSchema.safeParse(value);
  return result.success ? result.data : null;
}

const storage = createJSONStorage<ActAsSession | null>(() => ({
  getItem: (key) => {
    const saved = localStorage.getItem(key);
    try {
      if (saved && parseActAsSession(JSON.parse(saved))) return saved;
    } catch {
      /* Previous releases stored only a user ID; discard invalid sessions. */
    }
    if (saved) localStorage.removeItem(key);
    return null;
  },
  setItem: (key, value) => localStorage.setItem(key, value),
  removeItem: (key) => localStorage.removeItem(key),
}));

const actAsUserAtom = atomWithStorage<ActAsSession | null>(
  storageKey,
  null,
  storage,
  { getOnInit: true },
);
export const actAsUserIdentityAtom = atom(
  (get) => get(actAsUserAtom)?.actAsUserId ?? null,
);
export default actAsUserAtom;
